import { FirstDirection } from './firstdirection.model';

export class OpenLRExtendedLinear {
  firstDirection: FirstDirection;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrextendedlinear.model.ts